export default {
  name: 'title',
  component_path: 'modules/procedures/blocks/static/BlockTitle'
}